import { Wifi, WifiOff, RefreshCw, Cloud, CloudOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import useOnlineStatus from '@/hooks/useOnlineStatus';

export default function OnlineStatusIndicator({ showSyncButton = true }) {
  const { isOnline, isSyncing, handleSync } = useOnlineStatus();

  if (isOnline && !showSyncButton) {
    return null;
  }

  return (
    <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
      isOnline 
        ? 'bg-green-100 text-green-700' 
        : 'bg-red-100 text-red-700 animate-pulse'
    }`}>
      {isOnline ? (
        <>
          <Wifi className="w-3.5 h-3.5" />
          <span>Online</span>
          {showSyncButton && (
            <Button
              variant="ghost"
              size="sm"
              onClick={handleSync}
              disabled={isSyncing}
              className="h-5 w-5 p-0 ml-1 hover:bg-green-200"
            >
              <RefreshCw className={`w-3 h-3 ${isSyncing ? 'animate-spin' : ''}`} />
            </Button>
          )}
        </>
      ) : (
        <>
          <WifiOff className="w-3.5 h-3.5" />
          <span>Offline</span>
        </>
      )}
    </div>
  );
}

// Floating offline banner
export function OfflineBanner() {
  const { isOnline, isSyncing, handleSync } = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium shadow-lg">
      <CloudOff className="w-4 h-4" />
      <span>Anda sedang offline. Data akan disimpan secara tempatan.</span>
    </div>
  );
}

// Sync status badge for sidebar/navbar
export function SyncStatusBadge() {
  const { isOnline, isSyncing, lastSyncTime, handleSync } = useOnlineStatus();

  return (
    <button
      onClick={handleSync}
      disabled={!isOnline || isSyncing}
      className={`flex items-center gap-1.5 px-2 py-1 rounded-lg text-xs transition-all ${
        isOnline 
          ? 'bg-green-50 text-green-600 hover:bg-green-100' 
          : 'bg-gray-100 text-gray-400 cursor-not-allowed'
      }`}
      title={lastSyncTime ? `Terakhir sync: ${lastSyncTime.toLocaleTimeString()}` : 'Belum sync'}
    >
      {isOnline ? (
        <Cloud className={`w-3.5 h-3.5 ${isSyncing ? 'animate-pulse' : ''}`} />
      ) : (
        <CloudOff className="w-3.5 h-3.5" />
      )}
      <span>{isSyncing ? 'Syncing...' : isOnline ? 'Sync' : 'Offline'}</span>
    </button>
  );
}
